import { Injectable } from '@angular/core';

@Injectable()
export class BubleChartColorSelectionService {
// bubleColors = ["#fee3e2", "#fdaca9", "#fb746f", "#fa3d36", "#dc0d05"];
bubleColors = ["#E6958C", "#fa3d36", "#F50500", "#C10100", "#7D0300"];
randomColors = ["#FF9655",
               "#FFF263",
               "#6AF9C4",
               "#058DC7",
               "#50B432",
               "#7798BF",
               "#eeaaee",
               "#42A07B",
               "#86777F",
               "#514F78",
               "#251535",
               "#9c27b0",
               "#40C4FF",
               "#FDD089",
               "#A0446E",
               "#9B5E4A"]
constructor() {}
getBubleColor(x) {
  if (x < 2) {
    return this.bubleColors[0];
  } else if (x >= 2.0 && x <= 2.4) {
    return this.bubleColors[1];
  } else if (x > 2.4 && x <= 2.9) {
    return this.bubleColors[2];
  } else if (x > 2.9 && x <= 3.4) {
    return this.bubleColors[3];
  } else if (x > 3.4) {
    return this.bubleColors[4];
  } else {
    return "";
  }
}
getRandomColor(x) {
  if (x < 2) {
    return this.randomColors[0];
  }
  else if (x >= 2.0 && x <= 2.2){
    return this.randomColors[1];
  }
  else if (x > 2.2 && x <= 2.5){
    return this.randomColors[2];
  }
  else if (x > 2.5 && x <= 2.8){
    return this.randomColors[3];
  }
  else if (x > 2.8 && x <= 3){
    return this.randomColors[4];
  }
  else if (x > 3 && x <= 3.2){
    return this.randomColors[5];
  }
  else if (x > 3.2 && x <= 3.4){
    return this.randomColors[6];
  }
  else if (x > 3.4 && x <= 3.8){
    return this.randomColors[7];
  }
  else if (x > 3.8 && x <= 4){
    return this.randomColors[8];
  }
  else if (x > 4 && x <= 4.2){
    return this.randomColors[9];
  }
  else if (x > 4.2 && x <= 5){
    return this.randomColors[10];
  }
  else if (x > 5 && x <= 5.2){
    return this.randomColors[11];
  }
  else if (x > 5.2 && x <= 5.5){
    return this.randomColors[12];
  }
  else if (x > 5.5 && x <= 5.9){
    return this.randomColors[13];
  }
  else if (x > 5.9 && x <= 6.2){
    return this.randomColors[14];
  }
  else if (x > 6.2){
    return this.randomColors[15];
  }
  else {
    return "";
  }
}
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/buble-chart-color-selection.service.ts